/**
 * Turn a util.fetchApi response from the DHP (Dyrehelseportalen) endpoints into a
 * message we can show the vet, or '' when the call succeeded.
 *
 * The DHP handlers used to check only `response.error`. util.fetchApi (preact-util)
 * returns `{ stats, status, message }` with NO `error` property in two common failure
 * modes:
 *   - the server answered with a non-JSON body (an unhandled backend exception becomes
 *     an HTML 500 via Express' finalhandler — there is no error middleware), and
 *   - the fetch itself failed (offline, connection dropped).
 * Both left the vet clicking the DHP button with nothing happening at all and no error
 * message (TICKET-01280). Always route DHP responses through this helper.
 */

// The raw envelopes preact-util produces — an HTML dump or a JS stack is noise to a vet.
const OPAQUE_MESSAGE_PATTERN = /^ERROR (API did not return JSON|fetching API):/;

function stringifyError(error) {
    if (typeof error === 'string') {
        return error.trim();
    }
    if (typeof error.error === 'string') {
        return error.error.trim();
    }
    if (typeof error.message === 'string') {
        return error.message.trim();
    }
    try {
        return JSON.stringify(error);
    } catch (err) {
        return '';
    }
}

export function dhpErrorMessage(response) {
    if (!response) {
        return 'Fikk ikke svar fra serveren. Sjekk nettforbindelsen og prøv igjen.';
    }

    const { error, status, message } = response;

    if (error) {
        const text = stringifyError(error);
        if (text) {
            return text;
        }
    }

    if (status >= 400) {
        const detail = `${message || ''}`.trim();
        if (!detail || OPAQUE_MESSAGE_PATTERN.test(detail)) {
            return `Uventet feil fra serveren (${status}). Prøv igjen, og kontakt support hvis det gjentar seg.`;
        }
        return detail;
    }

    return '';
}

export default dhpErrorMessage;
